
import QuestionCircle from "../../../assets/filled/QuestionCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function QuestionCircleIcon({ className, dataTestid = "QuestionCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <QuestionCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
